import React from 'react';
import { Trans } from 'react-i18next';
import { Button, Sprite } from '@agissc/ktag-map';

interface NoLegendMessageProps {
  textKey: string;
  showButton: boolean;
  handleOnClick: () => void;
}

const NoLegendMessage = ({
  textKey,
  showButton,
  handleOnClick,
}: NoLegendMessageProps) => {
  const component = showButton ? (
    <span />
  ) : (
    <Button additionalClassNames="button__as-link" onClick={handleOnClick} />
  );

  return (
    <p>
      <Sprite id="i-circle" additionalClassNames="legend__icon" />{' '}
      <Trans ns="agisviewer" i18nKey={textKey} components={[component]} />
    </p>
  );
};

export default NoLegendMessage;
